// Auto-generated scarabs data from scarabs.txt
export interface Scarab {
    id: string;
    name: string;
    baseType: string;
    variant: string;
    limit: number;
    description: string;
  }
  
  export const scarabs: Record<string, Scarab> = {
    // "breach": {
    //   id: "breach",
    //   name: "Breach Scarab",
    //   baseType: "Breach Scarab",
    //   variant: "",
    //   limit: 5,
    //   description: "Area contains 2 additional Breaches",
    // },
    // "breach_the_dreamer": {
    //   id: "breach_the_dreamer",
    //   name: "Breach Scarab of the Dreamer",
    //   baseType: "Breach Scarab",
    //   variant: "the Dreamer",
    //   limit: 1,
    //   description: "Breaches in Area will always belong to Chayula",
    // },
    // "breach_lordship": {
    //   id: "breach_lordship",
    //   name: "Breach Scarab of Lordship",
    //   baseType: "Breach Scarab",
    //   variant: "Lordship",
    //   limit: 1,
    //   description: "Breaches in Area each contain a Breachlord",
    // },
    // "breach_splintering": {
    //   id: "breach_splintering",
    //   name: "Breach Scarab of Splintering",
    //   baseType: "Breach Scarab",
    //   variant: "Splintering",
    //   limit: 2,
    //   description: "Breach Monsters in Area drop 50% more Breach Splinters Clasped Hands in Area drop 50% more Breach Splinters",
    // },
    // "breach_snares": {
    //   id: "breach_snares",
    //   name: "Breach Scarab of Snares",
    //   baseType: "Breach Scarab",
    //   variant: "Snares",
    //   limit: 1,
    //   description: "Breaches in Area have 5 to 10 additional Clasped Hands Clasped Hands in Area are guarded by a rare Breach Monster",
    // },
    // "breach_resonant_cascade": {
    //   id: "breach_resonant_cascade",
    //   name: "Breach Scarab of Resonant Cascade",
    //   baseType: "Breach Scarab",
    //   variant: "Resonant Cascade",
    //   limit: 1,
    //   description: "Breaches in Areas open and close 10% faster for each Breach already opened Monsters from Breaches in Areas have increased Difficulty and Reward for each Breach already opened",
    // },
    "cartography_escalation": {
      id: "cartography_escalation",
      name: "Cartography Scarab of Escalation",
      baseType: "Cartography Scarab",
      variant: "Escalation",
      limit: 1,
      description: "10% increased Maps found in Area for each Map Modifier affecting Area",
    },
    "cartography_risk": {
      id: "cartography_risk",
      name: "Cartography Scarab of Risk",
      baseType: "Cartography Scarab",
      variant: "Risk",
      limit: 1,
      description: "Area has an additional random Modifier",
    },
    "cartography_singularity": {
      id: "cartography_singularity",
      name: "Cartography Scarab of Singularity",
      baseType: "Cartography Scarab",
      variant: "Singularity",
      limit: 1,
      description: "A Unique Map will drop from the Final Map Boss",
    },
    "cartography_corruption": {
      id: "cartography_corruption",
      name: "Cartography Scarab of Corruption",
      baseType: "Cartography Scarab",
      variant: "Corruption",
      limit: 1,
      description: "Non-Unique Maps found in Area are Corrupted with 8 Modifiers",
    },
    "cartography_the_multitude": {
      id: "cartography_the_multitude",
      name: "Cartography Scarab of the Multitude",
      baseType: "Cartography Scarab",
      variant: "the Multitude",
      limit: 3,
      description: "Area contains 8 to 12 additional packs of Difficult and Rewarding Monsters which drop 300% increased Maps",
    },
    "titanic": {
      id: "titanic",
      name: "Titanic Scarab",
      baseType: "Titanic Scarab",
      variant: "",
      limit: 1,
      description: "Unique Monsters have 2% increased Toughness, Damage, Rarity and Quantity of items dropped per 1% increased Pack Size of Area",
    },
    "titanic_treasures": {
      id: "titanic_treasures",
      name: "Titanic Scarab of Treasures",
      baseType: "Titanic Scarab",
      variant: "Treasures",
      limit: 3,
      description: "Unique Monsters in Area have 2 additional Rewards Unique Monsters in Area have 30% increased Toughness",
    },
    "titanic_legend": {
      id: "titanic_legend",
      name: "Titanic Scarab of Legend",
      baseType: "Titanic Scarab",
      variant: "Legend",
      limit: 1,
      description: "Unique Monsters in Area have 2 additional Monster Modifiers",
    },
    "bestiary": {
      id: "bestiary",
      name: "Bestiary Scarab",
      baseType: "Bestiary Scarab",
      variant: "",
      limit: 1,
      description: "Area contains Einhar",
    },
    "bestiary_the_herd": {
      id: "bestiary_the_herd",
      name: "Bestiary Scarab of the Herd",
      baseType: "Bestiary Scarab",
      variant: "the Herd",
      limit: 2,
      description: "Area contains 5 additional Red Beasts if it contains Einhar",
    },
    "bestiary_duplicating": {
      id: "bestiary_duplicating",
      name: "Bestiary Scarab of Duplicating",
      baseType: "Bestiary Scarab",
      variant: "Duplicating",
      limit: 1,
      description: "Create a copy of Beasts captured in Area",
    },
    "bestiary_the_shadowed_crow": {
      id: "bestiary_the_shadowed_crow",
      name: "Bestiary Scarab of the Shadowed Crow",
      baseType: "Bestiary Scarab",
      variant: "the Shadowed Crow",
      limit: 1,
      description: "Area contains The Black Mórrigan if it contains Einhar",
    },
    "influencing_the_shaper": {
      id: "influencing_the_shaper",
      name: "Influencing Scarab of the Shaper",
      baseType: "Influencing Scarab",
      variant: "the Shaper",
      limit: 1,
      description: "Adds Shaper Influence outcome to Area",
    },
    "influencing_the_elder": {
      id: "influencing_the_elder",
      name: "Influencing Scarab of the Elder",
      baseType: "Influencing Scarab",
      variant: "the Elder",
      limit: 1,
      description: "Adds Elder Influence outcome to Area",
    },
    "influencing_hordes": {
      id: "influencing_hordes",
      name: "Influencing Scarab of Hordes",
      baseType: "Influencing Scarab",
      variant: "Hordes",
      limit: 1,
      description: "Influenced Monster Packs in Area have 40% increased Pack Size",
    },
    "influencing_conversion": {
      id: "influencing_conversion",
      name: "Influencing Scarab of Conversion",
      baseType: "Influencing Scarab",
      variant: "Conversion",
      limit: 1,
      description: "Tier 14+ Maps found in Area have a chance to drop as Shaper Guardian, Elder Guardian, Conqueror or Unique Synthesised Maps instead",
    },
    "sulphite": {
      id: "sulphite",
      name: "Sulphite Scarab",
      baseType: "Sulphite Scarab",
      variant: "",
      limit: 1,
      description: "Area contains Niko Map owner gains 150% more Sulphite",
    },
    "sulphite_greed": {
      id: "sulphite_greed",
      name: "Sulphite Scarab of Greed",
      baseType: "Sulphite Scarab",
      variant: "Greed",
      limit: 1,
      description: "Map owner gains 150% more Sulphite",
    },
    "sulphite_fumes": {
      id: "sulphite_fumes",
      name: "Sulphite Scarab of Fumes",
      baseType: "Sulphite Scarab",
      variant: "Fumes",
      limit: 1,
      description: "Sulphite found in Map Area releases Enraging Fumes Monsters affected by Enraging Fumes have 50% increased Item Quantity Sulphite in your maps is guarded by Monsters from the Azurite Mine",
    },
    "divination_the_cloister": {
      id: "divination_the_cloister",
      name: "Divination Scarab of The Cloister",
      baseType: "Divination Scarab",
      variant: "The Cloister",
      limit: 5,
      description: "Area contains 8 to 12 additional packs of Doedre's Devoted Doedre's Devoted have 1% additional chance to drop a Stacked Deck",
    },
    "divination_plenty": {
      id: "divination_plenty",
      name: "Divination Scarab of Plenty",
      baseType: "Divination Scarab",
      variant: "Plenty",
      limit: 5,
      description: "Area contains 3 additional Packs of Magic Monsters that have 800% increased chance to drop Divination Cards",
    },
    "divination_pilfering": {
      id: "divination_pilfering",
      name: "Divination Scarab of Pilfering",
      baseType: "Divination Scarab",
      variant: "Pilfering",
      limit: 1,
      description: "Divination Cards which drop in Area are stolen by a Final Map Boss That Final Map Boss becomes more Difficult and deals increased Damage the more Divination Cards they have stolen That Final Map Boss duplicates all stolen Divination Cards when defeated",
    },
    "torment": {
      id: "torment",
      name: "Torment Scarab",
      baseType: "Torment Scarab",
      variant: "",
      limit: 2,
      description: "Area is haunted by 3 additional Tormented Spirits Tormented Spirits in Area have a 25% chance to be set free when Possessed Monsters are slain",
    },
    "torment_peculiarity": {
      id: "torment_peculiarity",
      name: "Torment Scarab of Peculiarity",
      baseType: "Torment Scarab",
      variant: "Peculiarity",
      limit: 1,
      description: "Tormented Spirits in Area are replaced with unusual variants",
    },
    "torment_release": {
      id: "torment_release",
      name: "Torment Scarab of Release",
      baseType: "Torment Scarab",
      variant: "Release",
      limit: 1,
      description: "Tormented Spirits in Area have a 25% chance to be set free when Possessed Monsters are slain",
    },
    "torment_possession": {
      id: "torment_possession",
      name: "Torment Scarab of Possession",
      baseType: "Torment Scarab",
      variant: "Possession",
      limit: 3,
      description: "Rare Monsters in Area have a quarter chance to be Possessed by up to 1 Tormented Spirit",
    },
    "ambush": {
      id: "ambush",
      name: "Ambush Scarab",
      baseType: "Ambush Scarab",
      variant: "",
      limit: 3,
      description: "Area contains 5 additional Strongboxes",
    },
    "ambush_hidden_compartments": {
      id: "ambush_hidden_compartments",
      name: "Ambush Scarab of Hidden Compartments",
      baseType: "Ambush Scarab",
      variant: "Hidden Compartments",
      limit: 1,
      description: "15% Chance for Strongboxes in Area to be openable again",
    },
    "ambush_potency": {
      id: "ambush_potency",
      name: "Ambush Scarab of Potency",
      baseType: "Ambush Scarab",
      variant: "Potency",
      limit: 1,
      description: "75% Increased effect of Explicit Modifiers on Strongboxes in Area",
    },
    "ambush_containment": {
      id: "ambush_containment",
      name: "Ambush Scarab of Containment",
      baseType: "Ambush Scarab",
      variant: "Containment",
      limit: 1,
      description: "Area contains many additional Strongboxes Area's inhabitants are lying in ambush",
    },
    "ambush_discernment": {
      id: "ambush_discernment",
      name: "Ambush Scarab of Discernment",
      baseType: "Ambush Scarab",
      variant: "Discernment",
      limit: 1,
      description: "Strongboxes in Area are more likely to be rarer varieties",
    },
    "harbinger": {
      id: "harbinger",
      name: "Harbinger Scarab",
      baseType: "Harbinger Scarab",
      variant: "",
      limit: 4,
      description: "Area contains 3 additional Harbingers",
    },
    "harbinger_obelisks": {
      id: "harbinger_obelisks",
      name: "Harbinger Scarab of Obelisks",
      baseType: "Harbinger Scarab",
      variant: "Obelisks",
      limit: 1,
      description: "Harbingers in Area spawn Empowered Obelisks Empowered Obelisks drop Currency Shards when defeated",
    },
    "harbinger_regency": {
      id: "harbinger_regency",
      name: "Harbinger Scarab of Regency",
      baseType: "Harbinger Scarab",
      variant: "Regency",
      limit: 1,
      description: "Harbingers in Area have a 50% chance to be replaced by a powerful Harbinger Boss",
    },
    "harbinger_warhoards": {
      id: "harbinger_warhoards",
      name: "Harbinger Scarab of Warhoards",
      baseType: "Harbinger Scarab",
      variant: "Warhoards",
      limit: 1,
      description: "Currency shards dropped by Harbingers in Area are duplicated",
    },
    "expedition": {
      id: "expedition",
      name: "Expedition Scarab",
      baseType: "Expedition Scarab",
      variant: "",
      limit: 1,
      description: "Area contains an Expedition Encounter",
    },
    "expedition_runefinding": {
      id: "expedition_runefinding",
      name: "Expedition Scarab of Runefinding",
      baseType: "Expedition Scarab",
      variant: "Runefinding",
      limit: 2,
      description: "Expedition Encounters in Area have 100% increased number of Runic Monster Markers",
    },
    "expedition_verisium_powder": {
      id: "expedition_verisium_powder",
      name: "Expedition Scarab of Verisium Powder",
      baseType: "Expedition Scarab",
      variant: "Verisium Powder",
      limit: 1,
      description: "Expedition Encounters in Area have 20% increased number of Explosives 80% increased Explosive Radius",
    },
    "expedition_the_skald": {
      id: "expedition_the_skald",
      name: "Expedition Scarab of the Skald",
      baseType: "Expedition Scarab",
      variant: "the Skald",
      limit: 1,
      description: "Expedition Encounters in Area are lead by Dannig",
    },
    "expedition_archaeology": {
      id: "expedition_archaeology",
      name: "Expedition Scarab of Archaeology",
      baseType: "Expedition Scarab",
      variant: "Archaeology",
      limit: 1,
      description: "Remnants in Expedition Encounters in Area have 2 additional Suffixes and Prefixes",
    },
    "legion": {
      id: "legion",
      name: "Legion Scarab",
      baseType: "Legion Scarab",
      variant: "",
      limit: 5,
      description: "Area contains an additional Legion Encounter",
    },
    "legion_officers": {
      id: "legion_officers",
      name: "Legion Scarab of Officers",
      baseType: "Legion Scarab",
      variant: "Officers",
      limit: 1,
      description: "Legion Factions in Area have 5 additional Sergeants",
    },
    "legion_command": {
      id: "legion_command",
      name: "Legion Scarab of Command",
      baseType: "Legion Scarab",
      variant: "Command",
      limit: 1,
      description: "Legion Factions in Area are accompanied by a General",
    },
    "legion_the_sekhema": {
      id: "legion_the_sekhema",
      name: "Legion Scarab of The Sekhema",
      baseType: "Legion Scarab",
      variant: "The Sekhema",
      limit: 1,
      description: "Legion Encounters in Area always contain the Maraketh Faction",
    },
    "legion_eternal_conflict": {
      id: "legion_eternal_conflict",
      name: "Legion Scarab of Eternal Conflict",
      baseType: "Legion Scarab",
      variant: "Eternal Conflict",
      limit: 1,
      description: "Legion Monsters in Area can be broken out of Stasis multiple times Legion Monsters in Area gain increased Difficulty and Reward for each time they are broken out",
    },
    "abyss": {
      id: "abyss",
      name: "Abyss Scarab",
      baseType: "Abyss Scarab",
      variant: "",
      limit: 2,
      description: "Area contains an additional Abyss",
    },
    "abyss_multitudes": {
      id: "abyss_multitudes",
      name: "Abyss Scarab of Multitudes",
      baseType: "Abyss Scarab",
      variant: "Multitudes",
      limit: 2,
      description: "Abysses in Area spawn 75% increased Monsters",
    },
    "abyss_edifice": {
      id: "abyss_edifice",
      name: "Abyss Scarab of Edifice",
      baseType: "Abyss Scarab",
      variant: "Edifice",
      limit: 1,
      description: "Abysses in Area that do not lead to an Abyssal Depths lead to a Stygian Spire Abysses in Area spawn Hoards as they travel",
    },
    "abyss_emptiness": {
      id: "abyss_emptiness",
      name: "Abyss Scarab of Emptiness",
      baseType: "Abyss Scarab",
      variant: "Emptiness",
      limit: 1,
      description: "Rare Abyss Monsters in Area have a 50% chance to drop an additional Rare item with an Abyssal socket",
    },
    "abyss_profound_depth": {
      id: "abyss_profound_depth",
      name: "Abyss Scarab of Profound Depth",
      baseType: "Abyss Scarab",
      variant: "Profound Depth",
      limit: 1,
      description: "Monsters from Abysses in Areas have increased Difficulty and Reward for each prior Pit in that Abyss",
    },
    "anarchy": {
      id: "anarchy",
      name: "Anarchy Scarab",
      baseType: "Anarchy Scarab",
      variant: "",
      limit: 5,
      description: "Area contains 4 additional Rogue Exiles",
    },
    "anarchy_gigantification": {
      id: "anarchy_gigantification",
      name: "Anarchy Scarab of Gigantification",
      baseType: "Anarchy Scarab",
      variant: "Gigantification",
      limit: 2,
      description: "Wild Rogue Exiles in Area have a 30% chance to be replaced with a Rogue Giant",
    },
    "anarchy_partnership": {
      id: "anarchy_partnership",
      name: "Anarchy Scarab of Partnership",
      baseType: "Anarchy Scarab",
      variant: "Partnership",
      limit: 1,
      description: "Wild Rogue Exiles in Area have a 50% chance to appear in pairs",
    },
    "essence": {
      id: "essence",
      name: "Essence Scarab",
      baseType: "Essence Scarab",
      variant: "",
      limit: 5,
      description: "Area contains 2 additional Imprisoned Monsters",
    },
    "essence_ascent": {
      id: "essence_ascent",
      name: "Essence Scarab of Ascent",
      baseType: "Essence Scarab",
      variant: "Ascent",
      limit: 1,
      description: "Essences found in Area are a tier higher",
    },
    "essence_stability": {
      id: "essence_stability",
      name: "Essence Scarab of Stability",
      baseType: "Essence Scarab",
      variant: "Stability",
      limit: 1,
      description: "Using a Remnant of Corruption in Area can only result in upgrading or transforming Essences",
    },
    "essence_calcification": {
      id: "essence_calcification",
      name: "Essence Scarab of Calcification",
      baseType: "Essence Scarab",
      variant: "Calcification",
      limit: 1,
      description: "Rare monsters that are natural inhabitants of the Area are imprisoned by Essences",
    },
    "essence_adaptation": {
      id: "essence_adaptation",
      name: "Essence Scarab of Adaptation",
      baseType: "Essence Scarab",
      variant: "Adaptation",
      limit: 1,
      description: "Imprisoned Monsters released in Areas grant a random Essence Modifier to another Imprisoned Monster in the Area Imprisoned Monsters in Areas have increased Difficulty and Reward for each Essence Modifier",
    },
    "domination": {
      id: "domination",
      name: "Domination Scarab",
      baseType: "Domination Scarab",
      variant: "",
      limit: 4,
      description: "Area contains 2 additional Shrines",
    },
    "domination_apparitions": {
      id: "domination_apparitions",
      name: "Domination Scarab of Apparitions",
      baseType: "Domination Scarab",
      variant: "Apparitions",
      limit: 1,
      description: "Area contains 2 additional Apparition Shrines",
    },
    "domination_evolution": {
      id: "domination_evolution",
      name: "Domination Scarab of Evolution",
      baseType: "Domination Scarab",
      variant: "Evolution",
      limit: 2,
      description: "Area contains an additional Evolving Shrine",
    },
    "domination_terrors": {
      id: "domination_terrors",
      name: "Domination Scarab of Terrors",
      baseType: "Domination Scarab",
      variant: "Terrors",
      limit: 1,
      description: "Shrines in Area are guarded by an Atlas Boss Modifiers to the Final Map Boss also apply to these Atlas Bosses",
    },
    "ritual_selectiveness": {
      id: "ritual_selectiveness",
      name: "Ritual Scarab of Selectiveness",
      baseType: "Ritual Scarab",
      variant: "Selectiveness",
      limit: 2,
      description: "Rerolling Favours at Ritual Altars in Area has no cost the first 2 times Ritual Altars in Area allow rerolling Favours 1 additional time",
    },
    "ritual_wisps": {
      id: "ritual_wisps",
      name: "Ritual Scarab of Wisps",
      baseType: "Ritual Scarab",
      variant: "Wisps",
      limit: 1,
      description: "Ritual Altars in Area spawn a Wildwood Wisp Wildwood Wisps grant 70% increased Tribute Gained to nearby Players",
    },
    "ritual_abundance": {
      id: "ritual_abundance",
      name: "Ritual Scarab of Abundance",
      baseType: "Ritual Scarab",
      variant: "Abundance",
      limit: 2,
      description: "Rituals in Area offer 100% increased Favours",
    },
    "harvest": {
      id: "harvest",
      name: "Harvest Scarab",
      baseType: "Harvest Scarab",
      variant: "",
      limit: 1,
      description: "Area contains the Sacred Grove",
    },
    "harvest_doubling": {
      id: "harvest_doubling",
      name: "Harvest Scarab of Doubling",
      baseType: "Harvest Scarab",
      variant: "Doubling",
      limit: 1,
      description: "Lifeforce dropped by Harvest Monsters in Area is duplicated Harvest Monsters in Area have 100% more Life",
    },
    "harvest_cornucopia": {
      id: "harvest_cornucopia",
      name: "Harvest Scarab of Cornucopia",
      baseType: "Harvest Scarab",
      variant: "Cornucopia",
      limit: 1,
      description: "If Area contains the Sacred Grove, it will contain up to 1 additional Tier 4 seed of each type, if possible",
    },
    "incursion": {
      id: "incursion",
      name: "Incursion Scarab",
      baseType: "Incursion Scarab",
      variant: "",
      limit: 1,
      description: "Area contains Alva",
    },
    "incursion_invasion": {
      id: "incursion_invasion",
      name: "Incursion Scarab of Invasion",
      baseType: "Incursion Scarab",
      variant: "Invasion",
      limit: 3,
      description: "Area contains 12 to 16 additional packs of Incursion Monsters",
    },
    "incursion_champions": {
      id: "incursion_champions",
      name: "Incursion Scarab of Champions",
      baseType: "Incursion Scarab",
      variant: "Champions",
      limit: 2,
      description: "Incursions in Area have a 35% chance for all Monsters to be at least Magic Incursions in Area have 15% increased Pack Size",
    },
    "incursion_timelines": {
      id: "incursion_timelines",
      name: "Incursion Scarab of Timelines",
      baseType: "Incursion Scarab",
      variant: "Timelines",
      limit: 1,
      description: "Final Architect slain in Area will drop an Itemised Temple Itemised Temples dropped in Area are generated based on current Temple layout, but with randomised room tiers",
    },
    "betrayal": {
      id: "betrayal",
      name: "Betrayal Scarab",
      baseType: "Betrayal Scarab",
      variant: "",
      limit: 1,
      description: "Area contains Jun",
    },
    // "betrayal_intelligence": {
    //   id: "betrayal_intelligence",
    //   name: "Betrayal Scarab of Intelligence",
    //   baseType: "Betrayal Scarab",
    //   variant: "Intelligence",
    //   limit: 1,
    //   description: "150% Increased Intelligence gained from Immortal Syndicate targets encountered in Area",
    // },
    "betrayal_reinforcements": {
      id: "betrayal_reinforcements",
      name: "Betrayal Scarab of Reinforcements",
      baseType: "Betrayal Scarab",
      variant: "Reinforcements",
      limit: 1,
      description: "Immortal Syndicate Members in Area have 50% increased chance to be accompanied by reinforcements",
    },
    "betrayal_perpetuation": {
      id: "betrayal_perpetuation",
      name: "Betrayal Scarab of Perpetuation",
      baseType: "Betrayal Scarab",
      variant: "Perpetuation",
      limit: 2,
      description: "Defeated Immortal Syndicate targets in Area have a 50% chance",
    },
    "beyond": {
      id: "beyond",
      name: "Beyond Scarab",
      baseType: "Beyond Scarab",
      variant: "",
      limit: 1,
      description: "Slaying enemies close together in Area can attract monsters from Beyond this realm",
    },
    "beyond_corruption": {
      id: "beyond_corruption",
      name: "Beyond Scarab of Corruption",
      baseType: "Beyond Scarab",
      variant: "Corruption",
      limit: 1,
      description: "Items dropped by Beyond Demons in Area are Corrupted",
    },
    "beyond_haemophilia": {
      id: "beyond_haemophilia",
      name: "Beyond Scarab of Haemophilia",
      baseType: "Beyond Scarab",
      variant: "Haemophilia",
      limit: 2,
      description: "Beyond Portals in Area have 30% increased Merging Radius",
    },
    "beyond_resurgence": {
      id: "beyond_resurgence",
      name: "Beyond Scarab of Resurgence",
      baseType: "Beyond Scarab",
      variant: "Resurgence",
      limit: 1,
      description: "Beyond Bosses in Area are enraged on low life Beyond Bosses in Area drop 100% increased Tainted Currency Beyond Portals in Area have 30% increased chance to spawn a Unique Boss",
    },
    "beyond_the_invasion": {
      id: "beyond_the_invasion",
      name: "Beyond Scarab of the Invasion",
      baseType: "Beyond Scarab",
      variant: "the Invasion",
      limit: 1,
      description: "Rare and Unique Monsters slain in Area create 8 to 12 additional Beyond Portals",
    },
    "ultimatum": {
      id: "ultimatum",
      name: "Ultimatum Scarab",
      baseType: "Ultimatum Scarab",
      variant: "",
      limit: 1,
      description: "Area contains an Ultimatum Encounter",
    },
    "ultimatum_bribing": {
      id: "ultimatum_bribing",
      name: "Ultimatum Scarab of Bribing",
      baseType: "Ultimatum Scarab",
      variant: "Bribing",
      limit: 2,
      description: "Ultimatum Monsters grant 150% increased Experience Ultimatum Encounters grant rewards as though you completed 2 additional Rounds",
    },
    "ultimatum_dueling": {
      id: "ultimatum_dueling",
      name: "Ultimatum Scarab of Dueling",
      baseType: "Ultimatum Scarab",
      variant: "Dueling",
      limit: 1,
      description: "Ultimatum Encounters in Area will always lead to a Unique Boss if possible",
    },
    "ultimatum_catalysing": {
      id: "ultimatum_catalysing",
      name: "Ultimatum Scarab of Catalysing",
      baseType: "Ultimatum Scarab",
      variant: "Catalysing",
      limit: 1,
      description: "Ultimatum Encounters in Area will only offer Catalysts as Rewards to the Map Owner",
    },
    "ultimatum_inscription": {
      id: "ultimatum_inscription",
      name: "Ultimatum Scarab of Inscription",
      baseType: "Ultimatum Scarab",
      variant: "Inscription",
      limit: 1,
      description: "Ultimatum Encounter rewards in Area offering Catalysts will offer Inscribed Ultimatums to the Map Owner instead",
    },
    "delirium": {
      id: "delirium",
      name: "Delirium Scarab",
      baseType: "Delirium Scarab",
      variant: "",
      limit: 1,
      description: "Area contains a Mirror of Delirium",
    },
    "delirium_mania": {
      id: "delirium_mania",
      name: "Delirium Scarab of Mania",
      baseType: "Delirium Scarab",
      variant: "Mania",
      limit: 2,
      description: "Delirium Reward Meters fill 100% faster in Area Delirium in Area increases 50% faster with distance from the mirror",
    },
    "delirium_paranoia": {
      id: "delirium_paranoia",
      name: "Delirium Scarab of Paranoia",
      baseType: "Delirium Scarab",
      variant: "Paranoia",
      limit: 5,
      description: "Delirium Encounters in Area generate 2 additional Reward types",
    },
    "delirium_neuroses": {
      id: "delirium_neuroses",
      name: "Delirium Scarab of Neuroses",
      baseType: "Delirium Scarab",
      variant: "Neuroses",
      limit: 1,
      description: "Delirium Encounters in Area contain all Unique Delirium Bosses Can only be used with Tier 11+ Maps",
    },
    "delirium_delusions": {
      id: "delirium_delusions",
      name: "Delirium Scarab of Delusions",
      baseType: "Delirium Scarab",
      variant: "Delusions",
      limit: 1,
      description: "Maps found in Area have layers of Delirium",
    },
    "blight": {
      id: "blight",
      name: "Blight Scarab",
      baseType: "Blight Scarab",
      variant: "",
      limit: 1,
      description: "Area contains a Blight Encounter",
    },
    "blight_bounty": {
      id: "blight_bounty",
      name: "Blight Scarab of Bounty",
      baseType: "Blight Scarab",
      variant: "Bounty",
      limit: 2,
      description: "Blight Chests in Area have a 20% chance to be openable again",
    },
    "blight_the_blightheart": {
      id: "blight_the_blightheart",
      name: "Blight Scarab of the Blightheart",
      baseType: "Blight Scarab",
      variant: "the Blightheart",
      limit: 1,
      description: "Blight Encounters in Area have one Blighted Chest Blight Encounters in Area spawn many more waves of Enemies Blighted Chests in Area grow larger and more rewarding the more Blighted Enemies are slain",
    },
    "blight_blooming": {
      id: "blight_blooming",
      name: "Blight Scarab of Blooming",
      baseType: "Blight Scarab",
      variant: "Blooming",
      limit: 1,
      description: "Blight Encounters in Area have up to 3 additional Unique Bosses Unique enemies in Blight Encounters have 100% increased life Tier 14+ Blighted Maps found in Area drop as Blight-Ravaged Maps instead",
    },
    "blight_invigoration": {
      id: "blight_invigoration",
      name: "Blight Scarab of Invigoration",
      baseType: "Blight Scarab",
      variant: "Invigoration",
      limit: 1,
      description: "Each Empowering Tower in Areas grants Blighted Monsters in range increased Difficulty and Reward",
    },
    "monstrous_lineage": {
      id: "monstrous_lineage",
      name: "Scarab of Monstrous Lineage",
      baseType: "Scarab",
      variant: "Monstrous Lineage",
      limit: 2,
      description: "40% increased Magic Pack Size",
    },
    "adversaries": {
      id: "adversaries",
      name: "Scarab of Adversaries",
      baseType: "Scarab",
      variant: "Adversaries",
      limit: 2,
      description: "Area contains 4 additional Packs with Mirrored Rare Monsters",
    },
    "divinity": {
      id: "divinity",
      name: "Scarab of Divinity",
      baseType: "Scarab",
      variant: "Divinity",
      limit: 3,
      description: "Up to 2 additional Rare Monsters in Area will be Pantheon-Touched Apparitions spawned by Pantheon-Touched Monsters deal 100% increased damage",
    },
    "hunted_traitors": {
      id: "hunted_traitors",
      name: "Scarab of Hunted Traitors",
      baseType: "Scarab",
      variant: "Hunted Traitors",
      limit: 1,
      description: "Area contains Hunted Traitors",
    },
    "stability": {
      id: "stability",
      name: "Scarab of Stability",
      baseType: "Scarab",
      variant: "Stability",
      limit: 1,
      description: "Portals to Area have a 50% chance to not be consumed on use",
    },
    "the_commander": {
      id: "the_commander",
      name: "Scarab of the Commander",
      baseType: "Scarab",
      variant: "the Commander",
      limit: 1,
      description: "Grants an additional Kirac Mission on Map Completion",
    },
    "evolution": {
      id: "evolution",
      name: "Scarab of Evolution",
      baseType: "Scarab",
      variant: "Evolution",
      limit: 1,
      description: "10 Monster Packs in Area are upgraded to Magic",
    },
    "wisps": {
      id: "wisps",
      name: "Scarab of Wisps",
      baseType: "Scarab",
      variant: "Wisps",
      limit: 2,
      description: "Monsters in Area have a chance to be Empowered by 2000 Wildwood Wisps",
    },
    "bisection": {
      id: "bisection",
      name: "Scarab of Bisection",
      baseType: "Scarab",
      variant: "Bisection",
      limit: 1,
      description: "You can select the Nullify Prefixes or Nullify Suffixes crafting options on the Map Device",
    },
    "unity": {
      id: "unity",
      name: "Scarab of Unity",
      baseType: "Scarab",
      variant: "Unity",
      limit: 1,
      description: "All Magic Monsters in Area are in a Union of Souls Monsters in Area get 1% more Rarity of items dropped for each Empowered Soul, up to 500%",
    },
    "radiant_storms": {
      id: "radiant_storms",
      name: "Scarab of Radiant Storms",
      baseType: "Scarab",
      variant: "Radiant Storms",
      limit: 1,
      description: "Area contains a Resplendent Tempest",
    },
    "horned_bloodlines": {
      id: "horned_bloodlines",
      name: "Horned Scarab of Bloodlines",
      baseType: "Horned Scarab",
      variant: "Bloodlines",
      limit: 1,
      description: "Area has 150% increased Magic Monsters",
    },
    "horned_nemeses": {
      id: "horned_nemeses",
      name: "Horned Scarab of Nemeses",
      baseType: "Horned Scarab",
      variant: "Nemeses",
      limit: 2,
      description: "Rare Monsters in Area have 2 additional Modifiers",
    },
    "horned_preservation": {
      id: "horned_preservation",
      name: "Horned Scarab of Preservation",
      baseType: "Horned Scarab",
      variant: "Preservation",
      limit: 1,
      description: "",
    },
    "other_s_are_not_consumed_on_use": {
      id: "other_s_are_not_consumed_on_use",
      name: "Other Scarabs are not consumed on use",
      baseType: "Other Scarabs are not consumed on use",
      variant: "",
      limit: 1,
      description: "",
    },
    "horned_awakening": {
      id: "horned_awakening",
      name: "Horned Scarab of Awakening",
      baseType: "Horned Scarab",
      variant: "Awakening",
      limit: 1,
      description: "You can select one Imbued crafting option on the Map Device",
    },
    "horned_tradition": {
      id: "horned_tradition",
      name: "Horned Scarab of Tradition",
      baseType: "Horned Scarab",
      variant: "Tradition",
      limit: 1,
      description: "All Rare and Unique Monsters in Area have dropped items transformed by a Reward Modifier",
    },
    "horned_glittering": {
      id: "horned_glittering",
      name: "Horned Scarab of Glittering",
      baseType: "Horned Scarab",
      variant: "Glittering",
      limit: 1,
      description: "Players in Area gain increased Item Rarity and Item Quantity for each Monster slain recently, up to 200% and 100% respectively",
    },
    "kalguuran_scarab": {
      id: "kalguuran_scarab",
      name: "Kalguuran Scarab",
      baseType: "Kalguuran",
      variant: "",
      limit: 2,
      description: "Area contains an additional Ore Deposit",
    },
    "kalguuran_scarab_of_guarded_riches": {
      id: "kalguuran_scarab_of_guarded_riches",
      name: "Kalguuran Scarab of Guarded Riches",
      baseType: "Kalguuran",
      variant: "of Guarded Riches",
      limit: 1,
      description: "Monsters guarding Ore Deposits in Area are at least Magic",
    },
    "kalguuran_scarab_of_refinement": {
      id: "kalguuran_scarab_of_refinement",
      name: "Kalguuran Scarab of Refinement",
      baseType: "Kalguuran",
      variant: "of Refinement",
      limit: 1,
      description: "Ore Deposits in Area grant Smelted Bars instead of Marking Ore",
    },
    // "horned_pandemonium": {
    //   id: "horned_pandemonium",
    //   name: "Horned Scarab of Pandemonium",
    //   baseType: "Horned Scarab",
    //   variant: "Pandemonium",
    //   limit: 1,
    //   description: "Monster packs in Area have a 15% chance to be replaced by a random Atlas Boss Modifiers to the Final Map Boss also apply to these Atlas Bosses",
    // },
  };
  
  // Helper functions to work with scarabs
  export const getScarabsByBaseType = (): Record<string, Scarab[]> => {
    const groupedScarabs: Record<string, Scarab[]> = {};
    
    Object.values(scarabs).forEach(scarab => {
      if (!groupedScarabs[scarab.baseType]) {
        groupedScarabs[scarab.baseType] = [];
      }
      groupedScarabs[scarab.baseType].push(scarab);
    });
    
    return groupedScarabs;
  };
  
  export const getBaseTypeLimit = (baseType: string): number => {
    const scarabsOfType = Object.values(scarabs).filter(s => s.baseType === baseType);
    return Math.max(...scarabsOfType.map(s => s.limit));
  };